import { intl } from '../helpers/intl';

export const formatDateTime = (date?: Date): string | undefined => {
  if (intl && date) {
    return intl.formatDate(date, {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
  }

  return undefined;
};
